'use client'

import { Link } from '@/components/ui/deprecated-link'
import { Logo } from '@/components/sections/logo'
import { MainRoutes } from '@/utils/routes'
import Image from 'next/image'
import NextLink from 'next/link'

export function ErrorPage() {
  return (
    <>
      <div className="p-4 border-b border-border-divider">
        <div className="max-w-screen-2xl mx-auto">
          <NextLink href={MainRoutes.Home} prefetch={false}>
            <Logo hasName priority />
          </NextLink>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
        <div className="flex flex-col items-center max-w-2xl gap-8">
          <Image
            src="/assets/icons/warning.svg"
            alt=""
            width={64}
            height={64}
            className="w-20 h-20 dark:hidden"
          />
          <Image
            src="/assets/icons/warning-dark.svg"
            alt=""
            width={64}
            height={64}
            className="w-20 h-20 hidden dark:block"
          />
          <div>
            <h1 className="text-3xl font-bold text-copy-primary mb-2">
              Uh oh! We&apos;re experiencing technical issues
            </h1>

            <p className="text-copy-accent">
              Sorry, we hate &quot;downtime&quot; too! We&apos;re overhead
              paging the IT team to get on it. Please try again later or head
              over to &quot;Home&quot; to get back on track.
            </p>
          </div>
          <Link variant="primaryButton" href={MainRoutes.Home}>
            Back to Home
          </Link>
        </div>
      </div>
    </>
  )
}
